import { Component, computed, inject, input, output, signal } from "@angular/core"
import { PublishStatus, Story } from "redlineLibs"
import { SectionEnum } from "redlineLibs"
import { VideoViewComponent } from "../shared/fields/video/video-view.component"
import { StorageService } from "../../services/storage.service"

@Component({
  imports: [
    VideoViewComponent,
  ],
  standalone: true,
  template: `
    <div
      class="column outline outline-2 p-3"
      style="outline-style: dashed"
      [style.outline-style]="isPublished() ? 'solid': 'dashed'"
      [style.cursor]="showFullText() ? 'unset' : 'pointer'"
      (click)="expandView()"
    >
      <div class="row-nowrap">
        @if (imageView().src) {
          <div class="w-20 aspect-square">
            <img
              alt="image"
              [src]="imageView().src"
            />
          </div>
        }

        <div class="column">
          <div class="column gap-0">
            @if (title().value) {
              <div
                class="font-bold"
                [class]="showFullText() ? '' : 'line-clamp-2'"
                (click)="navigateToStory($event)"
              >
                {{ title().value }}
              </div>
            }
            @if (subTitle().value) {
              <div
                [class]="showFullText() ? '' : 'line-clamp-2'"
              >
                {{ subTitle().value }}
              </div>
            }
          </div>
        </div>
      </div>

      @if (videoView().src) {
        <e2e-video-view [videoUrl]="videoView().src"/>
      }

      @if (!showFullText()) {
        <div class="row">
          <div
            class="truncate"
          >
            {{ bodyValue() }}
          </div>
          <div
            class="text-accent ml-auto cursor-pointer
"
          >
            Read More
          </div>
        </div>
      }

      @if (showFullText()) {
        @if (bodyValue()) {
          <div
            [innerHTML]="bodyValue()"
          ></div>
        }
        <div class="row">
          @if (userName()) {
            <div class="italic">
              from
              <span class="text-primary">
                {{ userName() }}
              </span>
            </div>
          }
          <div
            class="text-accent ml-auto cursor-pointer"
            (click)="collapseView(); $event.stopPropagation()"
          >
            Read Less
          </div>
        </div>
      }

    </div>

  `,
  selector: "e2e-story-linked-story",
})
export class StoryLinkedStoryComponent {
  private storageService = inject(StorageService)

  goToLinkedStory = output()

  story = input.required<Story>()
  imageView = computed(() => ({
    alt: this.story()[SectionEnum.IMAGE].alt,
    src: this.storageService.getFileUrl(this.story()[SectionEnum.IMAGE].filePath),
  }))
  videoView = computed(() => {
    const video = this.story()?.[SectionEnum.VIDEO]
    return {
      src: (video?.filePath && this.storageService.getFileUrl(video.filePath)) || "",
    }
  })
  showFullText = signal(false)

  title = computed(() =>
    this.story()[SectionEnum.TITLE]
  )
  subTitle = computed(() =>
    this.story()[SectionEnum.SUBTITLE]
  )
  bodyValue = computed(() =>
    this.story()[SectionEnum.BODY].value
  )
  userName = computed(() =>
    this.story().created.userName
  )
  isPublished = computed(() =>
    this.story().status.publishStatus === PublishStatus.PUBLISHED
  )

  expandView() {
    this.showFullText.set(true)
  }

  collapseView() {
    this.showFullText.set(false)
  }

  navigateToStory(event: MouseEvent) {
    event.stopPropagation()
    this.goToLinkedStory.emit()
  }

}
